import ArrowDown from "@/assets/icons/chevron_down.svg?react";
import ArrowUp from "@/assets/icons/chevron_up.svg?react";
import Tooltip from "@/components/generic/Tooltip";
import { blue } from "@/utils/Colors";
import {
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useState } from "react";
import { useLocation } from "react-router-dom";

interface NavItemLvlOneProps {
  icon: React.ReactNode;
  label: string;
  sideDrawerIsOpen: boolean;
  pathsToHighlight: string[];
  handleClickArrow?: (sectionId: string) => void;
  onClickButton?: () => void;
  children?: React.ReactNode;
  openSections: Set<string>;
}
export default function NavItemLvlOne(props: Readonly<NavItemLvlOneProps>) {
  const location = useLocation();
  const [hovered, setHovered] = useState(false);

  const shouldBeHighlighted = props.pathsToHighlight.find((path) =>
    location.pathname.includes(path)
  );

  return (
    <>
      <Tooltip
        title={props.sideDrawerIsOpen ? "" : props.label}
        placement="right"
      >
        <ListItem
          disablePadding
          sx={{
            display: "flex",
          }}
        >
          <ListItemButton
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            sx={{
              display: "flex",
              flexDirection: "row",
              borderRadius: 1,
              padding: 1,
              justifyContent: props.sideDrawerIsOpen ? "initial" : "center",
              gap: 1,
              ...(shouldBeHighlighted && {
                backgroundColor: blue[200],
                color: blue[800],
              }),
              "&:hover": { backgroundColor: blue[300], color: blue[600] },
            }}
            onClick={() => {
              props.onClickButton && props.onClickButton();
              props.handleClickArrow && props.handleClickArrow(props.label);
            }}
          >
            <ListItemIcon
              sx={{
                color: blue[900],
                ...(shouldBeHighlighted && {
                  color: blue[800],
                }),
                ...(hovered && {
                  color: blue[700],
                }),
                // minWidth: 0,
                // mr: props.sideDrawerIsOpen ? 3 : "auto",
                justifyContent: "center",
              }}
            >
              {props.icon}
            </ListItemIcon>
            <ListItemText
              primary={props.label}
              primaryTypographyProps={{
                variant: "body2",
                sx: {
                  ...(shouldBeHighlighted && {
                    color: blue[800],
                  }),
                  ...(hovered && {
                    color: blue[600],
                  }),
                },
              }}
              sx={{
                margin: 0,
                ...(!props.sideDrawerIsOpen && { display: "none" }),
              }}
            />
            {!!props.children &&
              props.sideDrawerIsOpen &&
              (props.openSections.has(props.label) ? (
                <ArrowUp
                  onClick={(event) => {
                    event.stopPropagation();
                    props.handleClickArrow &&
                      props.handleClickArrow(props.label);
                  }}
                />
              ) : (
                <ArrowDown
                  onClick={(event) => {
                    event.stopPropagation();
                    props.handleClickArrow &&
                      props.handleClickArrow(props.label);
                  }}
                />
              ))}
          </ListItemButton>
        </ListItem>
      </Tooltip>
      {!!props.children && (
        <Collapse
          in={props.openSections.has(props.label) && props.sideDrawerIsOpen}
          timeout="auto"
          unmountOnExit
          sx={{ paddingTop: 0.5 }}
        >
          <List
            component="div"
            disablePadding
            sx={{ display: "flex", flexDirection: "column", paddingLeft: 2 }}
          >
            {props.children}
          </List>
        </Collapse>
      )}
    </>
  );
}
